import {
  DeleteDialogComponent,
  PaginationComponent,
  ToastComponent,
} from '../distributed-ui-components';
import { RouterModule } from '@angular/router';
import { CommonModule, NgFor } from '@angular/common';
import { PipeModule } from '../../core/utilities';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { NgSelectModule } from '@ng-select/ng-select';
import { PagerService } from '../../core/services/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TableViewComponent } from './table-view/table-view.component';
import { GDPRService } from './../../core/services/rulebook/gdpr.service';
import { SessionService } from './../../core/services/auth/session.service';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { LibraryFiltersComponent } from './library-filters/library-filters.component';
import { RegulationService } from './../../core/services/regulation/regulation.service';
import { RulebookFiltersComponent } from './rulebook-filters/rulebook-filters.component';
import { BulkCloseDialogComponent } from './bulk-close-dialog/bulk-close-dialog.component';
import { RegulatoryFiltersComponent } from './regulatory-filters/regulatory-filters.component';
import { AuditTrailFiltersComponent } from './audit-trail-filters/audit-trail-filters.component';
import { JurisdictionDialogComponent } from './jurisdiction-dialog/jurisdiction-dialog.component';
import { ShareLibraryDialogComponent } from './share-library-dialog/share-library-dialog.component';
import { ChangeViewerDialogComponent } from './change-viewer-dialog/change-viewer-dialog.component';
import { UserManagementService } from './../../core/services/user-management/user-management.service';
import { StaticLibraryDialogComponent } from './static-library-dialog/static-library-dialog.component';
import { PublishReportDialogComponent } from './publish-report-dialog/publish-report-dialog.component';
import { LinkedUpdatesFiltersComponent } from './linked-updates-filters/linked-updates-filters.component';
import { SelfAssessmentFilterComponent } from './self-assessment-filter/self-assessment-filter.component';
import { ImpactAssessmentFilterComponent } from './impact-assessment-filter/impact-assessment-filter.component';
import { RegulationLibraryDialogComponent } from './regulation-library-dialog/regulation-library-dialog.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatChipsModule, MAT_CHIPS_DEFAULT_OPTIONS } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { DatePipe } from '@angular/common';
import { ImpactAssessmentT4FilterComponent } from './impact-assessment-t4-filter/impact-assessment-t4-filter.component';
import { MatIconModule } from '@angular/material/icon';
import { CopyDialogComponent } from './copy-dialog/copy-dialog.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AppendAssessListComponent } from './append-assess-list/append-assess-list.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import {StringtoarrPipe} from './stringtoarr.pipe';
import { SelfAssessmentT2FilterComponent } from './self-assessment-t2-filter/self-assessment-t2-filter.component';
import { ImpactAssessmentT5FilterComponent } from './impact-assessment-t5-filter/impact-assessment-t5-filter.component';
import { SelfAssessmentT3FilterComponent } from './self-assessment-t3-filter/self-assessment-t3-filter.component';
import { ImpactAssessmentT6FilterComponent } from './impact-assessment-t6-filter/impact-assessment-t6-filter.component';



const DIS_COMPONENTS = [
  DeleteDialogComponent,
  PaginationComponent,
  ToastComponent,
  RegulatoryFiltersComponent,
  LibraryFiltersComponent,
  RulebookFiltersComponent,
  LinkedUpdatesFiltersComponent,
  AuditTrailFiltersComponent,
  SelfAssessmentFilterComponent,
  ImpactAssessmentFilterComponent,
  ImpactAssessmentT6FilterComponent,
  ImpactAssessmentT4FilterComponent,
  CopyDialogComponent,
  SelfAssessmentT2FilterComponent,
  ImpactAssessmentT5FilterComponent,
  SelfAssessmentT3FilterComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    PipeModule,
    MatAutocompleteModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatChipsModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    NgSelectModule,
    MatIconModule,
    MatExpansionModule,
    BsDropdownModule,
    NgFor,
    ScrollingModule
    //SharedUIModule
  ],
  declarations: [
    DIS_COMPONENTS,
    TableViewComponent,
    RulebookFiltersComponent,
    LinkedUpdatesFiltersComponent,
    AuditTrailFiltersComponent,
    SelfAssessmentFilterComponent,
    ChangeViewerDialogComponent,
    ImpactAssessmentFilterComponent,
    ImpactAssessmentT6FilterComponent,
    BulkCloseDialogComponent,
    JurisdictionDialogComponent,
    RegulationLibraryDialogComponent,
    ShareLibraryDialogComponent,
    StaticLibraryDialogComponent,
    PublishReportDialogComponent,
    ImpactAssessmentT4FilterComponent,
    CopyDialogComponent,
    AppendAssessListComponent,
    StringtoarrPipe,
    SelfAssessmentT2FilterComponent,
    ImpactAssessmentT5FilterComponent,
    SelfAssessmentT3FilterComponent,
    ImpactAssessmentT6FilterComponent,
    
  ],
  exports: [
    DIS_COMPONENTS,
    ChangeViewerDialogComponent,
    StringtoarrPipe
  ],
  providers: [
    DatePipe,
    PagerService,
    GDPRService,
    AnalyticsService,
    SessionService,
    RegulationService,
    UserManagementService,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    {
      provide: MAT_CHIPS_DEFAULT_OPTIONS,
      useValue: { separatorKeyCodes: [ENTER, COMMA] },
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [
    DeleteDialogComponent,
    ChangeViewerDialogComponent,
    BulkCloseDialogComponent,
    JurisdictionDialogComponent,
    ShareLibraryDialogComponent,
    StaticLibraryDialogComponent,
    PublishReportDialogComponent,
    CopyDialogComponent
  ],
})
export class DistributedUIModule { }
